// import React from "react";
// import "./about.css";
// import Navbar from "../../p-components/navbar/Navbar";

// export const About = () => {
//   return (
//     <div>
//       <Navbar />
//       <div className="blackstrip">
//         <p>OUR GOLDEN PAST</p>
//         <p>KYC&nbsp;(KNOW YOUR CHICKEN)</p>
//         <p>KFC CARE</p>
//         <p>KFC FEEDBACK</p>
//         <p>CAREERS</p>
//       </div>
//       <div className="welcomenote">
//         <div className="redcolor">
//           <h1>Welcome</h1> <br />
//           <h1>
//             <strong>CHICKEN LOVERS</strong>
//           </h1>
//         </div>
//         <div className="bannerimg"></div>
//       </div>

//       <div className="imgcards">
//         <div>
//           <h1 className="child">OUR CRISPY HERITAGE</h1>
//         </div>
//         <div>
//           <h1 className="child">ALL ABOUT CHICKEN</h1>
//         </div>
//         <div>
//           <h1 className="child">BEING FAST FOOD</h1>
//         </div>
//         <div>
//           <h1 className="child">JOIN THE COLONEL'S CREW</h1>
//         </div>
//       </div>

//       <div className="journey">
//         <div className="journeytext">
//           <h1>Journey of fried chicken, through the ages</h1>
//           <p>
//             It all started with Colonel Harland Sanders creating a finger
//             lickin’ good recipe more than 75 years ago. A list of secret herbs
//             and spices scratched out on the back of his kitchen <br />
//             door, that continues to be followed across 145 countries, with more
//             than 800,000 team members breading and freshly preparing bucket
//             after bucket of our signature Hot & <br />
//             Crispy chicken. The Colonel’s Secret Recipe continues to be as
//             guarded; and our commitment towards Food, People and Planet remains
//             as steadfast. With a new KFC restaurant <br />
//             opening every 6 hours, we power on to serve the World’s Tastiest
//             Chicken!
//           </p>
//         </div>
//         <div className="demographics">
//           <div className="demoinfo">
//             <img
//               src="https://about.kfc.co.in/assets/images/D/Icons/calendar.png"
//               alt=""
//             />
//             <p>Since</p>
//             <h2>1930</h2>
//             <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAAeCAYAAAB5c901AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABNSURBVHgB7c9BDQAgAMPAgQ4c4F8KDvABFuBHSe+9LGmZ6SsXWkY52b3yW/M5A+kMpDOQzkA6A+kMpDOQzkA6A+kMpDOQzkA6A+kMpNu9MQhKmC+cDgAAAABJRU5ErkJggg==" alt="" />
//           </div>
//           <div className="demoinfo">
//           <img
//               src="https://about.kfc.co.in/assets/images/D/Icons/country.png"
//               alt=""
//             />
//             <p>Countries</p>
//             <h2>145</h2>
//             <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAAeCAYAAAB5c901AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABNSURBVHgB7c9BDQAgAMPAgQ4c4F8KDvABFuBHSe+9LGmZ6SsXWkY52b3yW/M5A+kMpDOQzkA6A+kMpDOQzkA6A+kMpDOQzkA6A+kMpNu9MQhKmC+cDgAAAABJRU5ErkJggg==" alt="" />
//           </div>
//           <div className="demoinfo">
//           <img
//               src="https://about.kfc.co.in/assets/images/D/Icons/kfc-board.png"
//               alt=""
//             />
//             <p>Restaurants</p>
//             <h2>25k+</h2>
//             <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAAeCAYAAAB5c901AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABNSURBVHgB7c9BDQAgAMPAgQ4c4F8KDvABFuBHSe+9LGmZ6SsXWkY52b3yW/M5A+kMpDOQzkA6A+kMpDOQzkA6A+kMpDOQzkA6A+kMpNu9MQhKmC+cDgAAAABJRU5ErkJggg==" alt="" />
//           </div>
//           <div className="demoinfo">
//           <img
//               src="https://about.kfc.co.in/assets/images/D/Icons/kitchen-lovers.png"
//               alt=""
//             />
//             <p>Team Members</p>
//             <h2>800k+</h2>
//             <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAAeCAYAAAB5c901AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABNSURBVHgB7c9BDQAgAMPAgQ4c4F8KDvABFuBHSe+9LGmZ6SsXWkY52b3yW/M5A+kMpDOQzkA6A+kMpDOQzkA6A+kMpDOQzkA6A+kMpNu9MQhKmC+cDgAAAABJRU5ErkJggg==" alt="" />
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };
import React from "react";
import "./about.css";
import Navbar from "../../p-components/navbar/Navbar";

export const About = () => {
  return (
    <div>
      <Navbar />
      <div className="blackstrip">
        <p>OUR ROOTS</p>
        <p>MENU</p>
        <p>SERVICES</p>
        <p>FEEDBACK</p>
        <p>CAREERS</p>
      </div>
      <div className="welcomenote">
        <div className="redcolor">
          <h1>Welcome</h1> <br />
          <h1>
            <strong>FOOD LOVERS</strong>
          </h1>
        </div>
        <div className="bannerimg"></div>
      </div>

      <div className="imgcards">
        <div>
          <h1 className="child">OUR HERITAGE</h1>
        </div>
        <div>
          <h1 className="child">AUTHENTIC SOUTH INDIAN CUISINE</h1>
        </div>
        <div>
          <h1 className="child">FRESH, LOCAL INGREDIENTS</h1>
        </div>
        <div>
          <h1 className="child">JOIN OUR FAMILY</h1>
        </div>
      </div>

      <div className="journey">
        <div className="journeytext">
          <h1>The Story of Kanishka Dhaba</h1>
          <p>
            Established by Kamalakar Rao and Ramchander Rao in the heart of
            Warangal, **Kanishka Dhaba** is a celebration of South Indian
            flavors and traditions. From our humble beginnings to becoming a
            cherished name in Warangal, we have stayed true to our mission:
            delivering authentic, flavorful dishes that bring joy to every
            table. <br />
            Our secret lies in the use of fresh, local ingredients and
            time-honored recipes passed down through generations. At Kanishka
            Dhaba, every dish is a story, every flavor a memory. <br />
            Join us for an unforgettable culinary experience, where tradition
            meets taste in every bite.
          </p>
        </div>
        <div className="demographics">
          <div className="demoinfo">
            <img
              src="https://via.placeholder.com/100"
              alt=""
            />
            <p>Established</p>
            <h2>1990</h2>
            <img
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAAeCAYAAAB5c901AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABNSURBVHgB7c9BDQAgAMPAgQ4c4F8KDvABFuBHSe+9LGmZ6SsXWkY52b3yW/M5A+kMpDOQzkA6A+kMpDOQzkA6A+kMpDOQzkA6A+kMpNu9MQhKmC+cDgAAAABJRU5ErkJggg=="
              alt=""
            />
          </div>
          <div className="demoinfo">
            <img
              src="https://via.placeholder.com/100"
              alt=""
            />
            <p>City</p>
            <h2>Warangal</h2>
            <img
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAAeCAYAAAB5c901AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABNSURBVHgB7c9BDQAgAMPAgQ4c4F8KDvABFuBHSe+9LGmZ6SsXWkY52b3yW/M5A+kMpDOQzkA6A+kMpDOQzkA6A+kMpDOQzkA6A+kMpNu9MQhKmC+cDgAAAABJRU5ErkJggg=="
              alt=""
            />
          </div>
          <div className="demoinfo">
            <img
              src="https://via.placeholder.com/100"
              alt=""
            />
            <p>Specialties</p>
            <h2>Dosa, Sambar, Biryani</h2>
            <img
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAAeCAYAAAB5c901AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABNSURBVHgB7c9BDQAgAMPAgQ4c4F8KDvABFuBHSe+9LGmZ6SsXWkY52b3yW/M5A+kMpDOQzkA6A+kMpDOQzkA6A+kMpDOQzkA6A+kMpNu9MQhKmC+cDgAAAABJRU5ErkJggg=="
              alt=""
            />
          </div>
          <div className="demoinfo">
            <img
              src="https://via.placeholder.com/100"
              alt=""
            />
            <p>Team</p>
            <h2>Family-Run</h2>
            <img
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAAeCAYAAAB5c901AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABNSURBVHgB7c9BDQAgAMPAgQ4c4F8KDvABFuBHSe+9LGmZ6SsXWkY52b3yW/M5A+kMpDOQzkA6A+kMpDOQzkA6A+kMpDOQzkA6A+kMpNu9MQhKmC+cDgAAAABJRU5ErkJggg=="
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  );
};
